'use client';

import { PureComponent } from 'react';
import { styled } from '@linaria/react';

import Paper from '@/components/Paper';
import Bezier from './Bezier';

class BezierFlattener extends PureComponent {
  state = {
    flattened: true,
  };

  componentDidMount() {
    this.intervalId = window.setInterval(this.tick, 2000);
  }

  componentWillUnmount() {
    window.clearInterval(this.intervalId);
  }

  tick = () => {
    const QUERY = '(prefers-reduced-motion: no-preference)';

    const prefersReducedMotion = !window.matchMedia(QUERY).matches;

    if (prefersReducedMotion) {
      return;
    }

    this.setState({ flattened: !this.state.flattened });
  };

  render() {
    const { flattened } = this.state;

    const y1 = flattened ? 200 : 0;
    const y2 = flattened ? 200 : 400;

    return (
      <Wrapper>
        <Bezier
          viewBoxWidth={1000}
          viewBoxHeight={400}
          points={[
            [25, 200],
            [333, y1],
            [666, y2],
            [975, 200],
          ]}
          grabbable={false}
        />
      </Wrapper>
    );
  }
}

const Wrapper = styled(Paper)`
  padding: 16px;
  margin-bottom: 48px;
`;

export default BezierFlattener;
